const h = (t) => {
  const s = new Blob([t], { type: "video/mp4" });
  return URL.createObjectURL(s);
}, l = async (t, s) => {
  const { scale: i = 1, mimeType: a, quality: o = 1, cros: r = !0 } = s, e = new Image();
  return r && (e.crossOrigin = "anonymous"), new Promise((c, u) => {
    e.onload = () => {
      const n = document.createElement("canvas"), d = n.getContext("2d");
      n.width = e.width / i, n.height = e.height / i, d.drawImage(e, 0, 0, n.width, n.height);
      const m = n.toDataURL(a, o);
      c(m);
    }, e.onerror = (n) => {
      u(n);
    }, e.src = t;
  });
}, g = async (t, s) => {
  const { scale: i = 1, mimeType: a, quality: o = 1, cros: r = !0 } = s, e = document.createElement("video");
  return e.muted = !0, r && (e.crossOrigin = "anonymous"), new Promise((c, u) => {
    r && e.setAttribute("crossOrigin", "anonymous"), e.setAttribute("width", "400"), e.setAttribute("height", "240"), e.setAttribute("preload", "auto"), e.setAttribute("webkit-playsinline", "true"), e.setAttribute("playsinline", "true"), e.setAttribute("autoplay", "true"), e.setAttribute("src", t), e.addEventListener("canplaythrough", () => {
      const n = document.createElement("canvas"), d = n.getContext("2d");
      n.width = e.width / i, n.height = e.height / i, setTimeout(() => {
        d.drawImage(e, 0, 0, n.width, n.height), c(n.toDataURL(a, o));
      }, 300);
    }), e.addEventListener("error", (n) => {
      u(n);
    });
  });
}, p = async (t, s = 4) => {
  const i = t.type ?? "", a = new Blob([t], { type: i }), o = URL.createObjectURL(a);
  if (i.includes("image"))
    return l(o, { scale: s, mimeType: "image/jpeg" });
  if (i.includes("video"))
    return g(o, { scale: s, mimeType: "image/jpeg" });
  throw new Error("Unsupported file type");
}, y = (t, s) => {
  const i = [...s], a = Array.isArray(t) ? t : [t];
  for (const o of a) {
    const r = i.findIndex(({ uid: e }) => e === o.uid);
    r === -1 ? i.push(o) : i[r] = { ...i[r], ...o };
  }
  return i;
}, b = (t) => ({
  ...t,
  name: t.name,
  size: t.size,
  type: t.type,
  uid: t.uid,
  percent: 0,
  originFileObj: t
});
export {
  b as file2Obj,
  h as getFileBlob,
  p as getFileThumb,
  l as imageUrlToBase64,
  y as updateFileList,
  g as videoUrlToBase64
};
//# sourceMappingURL=fileUtil.mjs.map
